@use "../../../node_modules/@thelabnyc/breakpoint-sass/stylesheets/breakpoint";
@use "../../styles/layout";

.footerLinks {
    display: flex;
    justify-content: flex-end;
    gap: 1em;
    margin: 40px 0;

    @include breakpoint.breakpoint(layout.$belowMedium) {
        flex-wrap: wrap;
        justify-content: center;
    }
}

.footerLink {
    composes: button from "../../styles/buttons.module.scss";
}
